import React, {StrictMode, Suspense, lazy} from 'react';
// code splitting
import Loading from 'components/Loading';
// to build the store based on the reducer
import {applyMiddleware} from 'redux';
// to configure the store for hot module replacement
import configureHotStore from 'utils/configureHotStore';
// to pass the store to childern
import {Provider} from 'react-redux';
// for asynchronous actions
import {thunk as thunkMiddleware} from 'redux-thunk';
// for logging
import {createLogger} from 'redux-logger';
// routing
import {BrowserRouter, HashRouter, Route, Routes, Navigate} from 'react-router-dom';
import {fetchWorks, fetchArtists} from 'actions/WorksActions';

// root reducer
import rootReducer from 'reducers/_rootReducer';
// Frame is always needed, so import it directly (not lazy)
import Frame from 'containers/FrameContainer';

// if (!PRODUCTION){
	console.log(
		`%c STAR WARPS %c ${VERSION || "testing"} `,
		'background: black; color: white;',
		'background: gray; color: white'
	);
	// }

let middlewares = [thunkMiddleware];
if (!PRODUCTION){
	middlewares.push(createLogger({
		collapsed: true,
		duration: true
	}));
}

const store = configureHotStore(
	rootReducer,
	'./reducers/_rootReducer',
	applyMiddleware(...middlewares)
);

// Lazy load route components (not Frame - it's needed on every page)
const Starfield = lazy(() => import('./containers/StarfieldContainer'));
const ThankYou = lazy(() => import('./containers/ThankYouContainer'));
const Grid = lazy(() => import('./containers/GridContainer'));
const Index = lazy(() => import('./containers/IndexContainer'));
const Gallery = lazy(() => import('./containers/GalleryContainer'));
const Additions = lazy(() => import('./containers/AdditionsContainer'));
const About = lazy(() => import('./components/About'));


const Router = PRODUCTION ? BrowserRouter : HashRouter;

// Wrapper to ensure Frame wraps all routes with Suspense
const AppRoutes = () => (
	<Frame>
		<Suspense fallback={<Loading key="loading"/>}>
			<Routes>
				<Route path="/" element={<Starfield/>}/>
				<Route path="/about" element={<Navigate to="/gallery/about" replace />}/>
				<Route path="/thankyou" element={<Navigate to="/gallery/ty" replace />}/>
				<Route path="/ty" element={<Navigate to="/gallery/ty" replace />}/>
				<Route path="/grid" element={<Grid/>}/>
				<Route path="/grid/:page" element={<Grid/>}/>
				<Route path="/search" element={<Index/>}/>
				<Route path="/search/:page" element={<Index/>}/>
				<Route path="/gallery" element={<Gallery/>}/>
				<Route path="/gallery/ty" element={<ThankYou/>}/>
				<Route path="/gallery/about" element={<About/>}/>
				<Route path="/gallery/:id" element={<Gallery/>}/>
				<Route path="/additions" element={<Additions/>}/>
				<Route path="/loading" element={<Loading />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</Suspense>
	</Frame>
);

export default () => (
	<Provider store={store}>
		<Router>
			<AppRoutes />
		</Router>
	</Provider>
);